var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{attrs:{"loading":_vm.loading,"small":"","color":"primary","disabled":_vm.disabled},on:{"click":function($event){$event.stopPropagation();$event.preventDefault();return _vm.submit($event)}}},[_vm._v(" Publish ")])}
var staticRenderFns = []

export { render, staticRenderFns }